"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var actionsRegistry_1 = require("./actionsRegistry");
function clearRegistry() {
    actionsRegistry_1.default.clear();
}
exports.clearRegistry = clearRegistry;
var defaultTransform = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return (__assign({}, args));
};
var validateType = function (type) {
    var re = /^@@([a-z0-9]+(?:\-?[a-z0-9]+))+\/([A-Z0-9]+(?:\_?[A-Z0-9]+))+$/;
    return re.test(type);
};
function createAction(type, transform) {
    if (transform === void 0) { transform = defaultTransform; }
    if (actionsRegistry_1.default.has(type)) {
        throw "Duplicate action " + type;
    }
    else {
        actionsRegistry_1.default.add(type);
    }
    if (!validateType(type)) {
        console.warn("Action type: " + type + " doesn't match regexp pattern /^@@([a-z0-9]+(?:\\-?[a-z0-9]+))+\\/([A-Z0-9]+(?:\\_?[A-Z0-9]+))+$/");
    }
    var actionCreator = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var params = transform.apply(void 0, args);
        if ('type' in params) {
            console.warn('Property type is reserved by action');
        }
        return Object.assign(params, { type: type });
    };
    actionCreator.toString = function () { return type; };
    actionCreator.valueOf = function () { return type + ","; };
    return actionCreator;
}
exports.default = createAction;
